"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Rules = function (_a) {
    var description = _a.description, bottomContent = _a.bottomContent;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.tableContainer },
        description && react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, description),
        bottomContent));
};
exports.default = Rules;
